import React from "react";
import CareerOne from "../../../Assets/CareersImg/CareersOne.png";

const CareerEnhance = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      <div className="pointer-events-none absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/25 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Left Content */}
          <div className="space-y-5 md:space-y-6" data-aos="fade-right">
            <p className="text-[10px] sm:text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-[#064585]">
              Careers
            </p>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight text-slate-900">
              Enhance Your{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
                Career
              </span>{" "}
              at Web_Bocket Classes
            </h1>
            <p className="text-slate-600 text-sm sm:text-base md:text-lg leading-relaxed max-w-2xl">
              At <span className="font-semibold">Web_Bocket Classes</span>, we
              believe in the power of education to change lives. Our mission is
              to create meaningful learning experiences that inspire growth,
              innovation, and personal transformation. We are looking for
              talented, passionate individuals who share our commitment to
              making high-quality education accessible to everyone.
            </p>
          </div>

          {/* Image */}
          <div
            className="relative h-full flex justify-center lg:justify-end"
            data-aos="fade-left"
          >
            <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-md border border-[#5989C8]/20 p-4 md:p-5 max-w-md w-full">
              <img
                src={CareerOne}
                alt="Career at Web_Bocket Classes"
                className="w-full h-auto object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerEnhance;
